import { DeleteProjectModalProps } from 'Features/Project/DeleteProjectModal/DeleteProjectModal.types'
import { Box } from '@mui/material'
import { Button, Modal } from 'Common/Supplyvue-ui'

/**
 * Confirm a project delete (design system: Dialog, confirm size). The actions
 * are in the footer and name what they do; the destructive one takes the
 * danger fill. They were "No" / "Yes" inside the body.
 */
export const DeleteProjectModal = ({
  isModalOpen,
  handleModalClose,
  projectName,
  handleConfirmClick,
}: DeleteProjectModalProps) => (
  <Modal
    open={isModalOpen}
    handleClose={handleModalClose}
    header="Delete project"
    size="sm"
    body={
      <Box sx={{ fontSize: 13, color: 'var(--ink-700)' }}>
        Delete{' '}
        <Box component="strong" sx={{ color: 'var(--ink-900)' }}>
          {projectName}
        </Box>
        ?
      </Box>
    }
    footer={
      <>
        <Button variant="outlined" onClick={handleModalClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleConfirmClick}>
          Delete project
        </Button>
      </>
    }
  />
)
